<template>
  <v-dialog v-model="isVisible" :max-width="maxWidth" @keydown.esc="hide()" :persistent="persistent" :hide-overlay="hideOverlay" data-testid="v-dialog_17fee1c4-8570-48ea-821a-24ae967cb3b1">
    <v-card :class="cssClass" tile data-testid="v-card_4db5240d-e9f2-4ff9-af98-b94ce90a62ad">
      <v-card-title v-if="title != null && title != ''" class="text-h5" primary-title>{{title}}</v-card-title>
      <v-card-text :class="(title == null || title == '') ? 'pt-5' : ''" v-if="$slots.default != null || $scopedSlots.default != null">
        <slot :data="data" :isLoading="isLoading"></slot>
      </v-card-text>
      <slot name="full-width-content" :data="data" :isLoading="isLoading"></slot>
      <v-card-text v-if="errorMessage != null">
        <v-alert :value="errorMessage != null" color="error" icon="warning" transition="scale-transition" data-testid="v-alert_307b6efc-4092-4385-842f-1f1d563cc164">{{errorMessage}}</v-alert>
      </v-card-text>
      <v-card-actions v-if="$slots['actions'] != null || $scopedSlots['actions'] != null || hasPrimaryAction() || hasSecondaryAction()">
        <slot name="actions">
          <v-spacer/>
          <v-btn v-if="hasPrimaryAction()" color="primary" @click="clicked(1, $event)" :loading="isLoading" :disabled="!primaryActionEnabled" data-testid="edit-save-button">{{ getPrimaryActionLabel() }}</v-btn>
          <v-btn v-if="hasSecondaryAction()" color="primary" text @click="clicked(2, $event)" :disabled="!secondaryActionEnabled"  data-testid="v-btn_32624853-57c1-4b46-80f4-db3697fea752">{{ getSecondaryActionLabel() }}</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: { type: String, required: false },
    primaryActionLabel: { type: String, required: false },
    secondaryActionLabel: { type: String, required: false },
    primaryActionEnabled: { type: Boolean, required: false, default: true },
    secondaryActionEnabled: { type: Boolean, required: false, default: true },
    autoshow: { type: Boolean, required: false },
    maxWidth: { type: Number, required: false, default: 800 },
    persistent: { type: Boolean, default: false },
    cssClass: { type: String, required: false },
    hideOverlay: { type: Boolean, required: false, default: false },
    needFeedback: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      isVisible: false,
      isLoading: false,
      data: null,
      errorMessage: null,
      gotFeedback: false,
    }
  },
  mounted() {
    if (this.autoshow) {
      this.show();
    }
  },
  watch: {
    isVisible(visible, was_visible) {
      if (was_visible && !visible) this.$emit('close');
    }
  },
  methods: {
    show(customdata, loading, clear_errors) {
      this.isVisible = true;
      if (customdata != undefined) {
        this.data = customdata;
      }
      if (loading != undefined) {
        this.isLoading = loading;
      }
      if (clear_errors != undefined && clear_errors) {
        this.errorMessage = null
      }
    },
    hide() {
      if (!this.needFeedback || this.gotFeedback) {
        this.isVisible = false;
      }
    },
    setData(customdata) {
      this.data = customdata;
    },
    setLoading(loading) {
      this.isLoading = loading;
    },
    setError(msg) {
      this.errorMessage = msg;
    },
    clearErrors() {
      this.errorMessage = null;
    },
    clicked(value, event) {
      this.gotFeedback = true;
      if (value == 1) {
        this.$emit('primary-click', event);
        if (!event.defaultPrevented) {
          this.clearErrors();
        }
      }
      if (value == 2) {
        this.$emit('secondary-click', event);
        if (!event.defaultPrevented) {
          this.hide();
        }
      }
    },
    getPrimaryActionLabel() {
      if (this.primaryActionLabel) return this.primaryActionLabel;
      return this.$t('ok');
    },
    getSecondaryActionLabel() {
      if (this.secondaryActionLabel) return this.secondaryActionLabel;
      return this.$t('cancel');
    },
    hasPrimaryAction() {
      return !(this.primaryActionLabel != undefined && this.primaryActionLabel == '');
    },
    hasSecondaryAction() {
      return !(this.secondaryActionLabel != undefined && this.secondaryActionLabel == '');
    }
  }
}
</script>

<style scoped lang="scss">
.v-dialog .v-card .v-card__title {
  padding-top: 24px;
}
.text-h5 {
  font-size: 24px !important;
  line-height: 1.4;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/CommonDialog.vue